const SKYX_HANDHELD_LANDSCAPE_MAX_HEIGHT_PX = 520;

/** Phone landscape is often `deviceType: 'tablet'` because the viewport is wide. */
export function isSkyxHandheldLandscape(
  deviceType: string,
  isLandscape: boolean
): boolean {
  if (!isLandscape || deviceType === 'desktop') {
    return false;
  }
  if (deviceType === 'mobile') {
    return true;
  }
  return (
    deviceType === 'tablet' &&
    typeof window !== 'undefined' &&
    window.innerHeight <= SKYX_HANDHELD_LANDSCAPE_MAX_HEIGHT_PX
  );
}
